// 收费管理路由
// 权限： 结算：balance
const ChargeMana = [
    // 抄读结算
    {
        path: '/readingmeter',
        component: resolve => require(['@/views/ChargeMana/ReadingAndClearing/ReadingAndClearing'], resolve),
        name: 'readingmeter',
        meta: { title: '抄读结算', breadcrumb: [{ menu: 'readingmeter' }], role: 'balance'}
    },
    // 业主结算
    {
        path: '/ownerclose',
        component: resolve => require(['@/views/ChargeMana/ReadingAndClearing/ClearingDetail/ClearingDetail'], resolve),
        name: 'ownerclose',
        meta: { title: '业主结算', breadcrumb: [{ menu: 'readingmeter', path: '/readingmeter' }, { menu: 'ownerclose' }], role: 'balance' }
    },
    // 费用打印
    {
        path: '/chargeprint',
        component: resolve => require(['@/views/ChargeMana/ChargePrint/ChargePrint'], resolve),
        name: 'chargeprint',
        meta: { title: '费用打印', breadcrumb: [{ menu: 'chargeprint' }], role: 'balance'}
    },
    // 表头设置
    {
        path: '/settingheader',
        component: resolve => require(['@/views/ChargeMana/ChargePrint/SettingHeader/SettingHeader'], resolve),
        name: 'billSetting',
        meta: { title: '表头设置', breadcrumb: [{ menu: 'chargeprint', path: '/chargeprint' }, { menu: 'billSetting' }], role: 'balance'}
    },
    // 打印预览
    {
        path: '/printpreview',
        component: resolve => require(['@/views/ChargeMana/ChargePrint/PrintPreview/PrintPreview'], resolve),
        name: 'printpreview',
        meta: { title: '打印预览', breadcrumb: [{ menu: 'chargeprint', path: '/chargeprint' }, { menu: 'printpreview' }], role: 'balance'}
    },
];

export default ChargeMana